import api from "./axios";
import type { FeedbackFormType, TicketType } from "@/struct/FeedbackStruct";

export default class FeedbackService {
  getTopics = () => {
    return api.get("/api/web-api/integration/otrs/get-topics");
  };
  sendFeedback = (data: FeedbackFormType) => {
    return api.post("/api/web-api/rating/create", { ...data });
  };
  sendTicket = (data: TicketType) => {
    return api.post("/api/web-api/integration/otrs/send-ticket", { ...data });
  };
}
